import React, { useRef, useEffect, useState } from 'react';
import { Fade, Paper, Popper, Typography, Box } from '@mui/material';
import { PsylarisDetailPopperStyle } from './style';
import { PLayerTriggeredBy } from '../../../../../../commands/practitioner/enums/PLayerTriggeredBy';
import DialogMediaPlayer from '../../../../../DialogMediaPlayer/DialogMediaPlayer';
import { ReactPlayerProps } from 'react-player';

interface PsylarisPannelDetailPopperProps {
  psylarisDetailModal: boolean;
  modalAnchorEl: React.RefObject<HTMLDivElement>;
  content: string;
  title: string;
  thumbnail: string;
  lastDiveIndex: boolean;
  url: string;
  mediaPopperVideo: boolean;
}

const PsylarisPannelDetailPopper = (props: PsylarisPannelDetailPopperProps) => {
  const { psylarisDetailPopper } = PsylarisDetailPopperStyle;
  const { psylarisDetailModal, title, content, modalAnchorEl, thumbnail, lastDiveIndex, url, mediaPopperVideo } = props;
  const isModalVisible = psylarisDetailModal && lastDiveIndex;

  const [isLoading, setIsLoading] = useState(true);
  const playerRef = useRef(null);

  useEffect(() => {
    if (mediaPopperVideo) {
      setIsLoading(false);
    }
  }, [mediaPopperVideo]);

  const config = {
    youtube: {
      playerVars: {
        showinfo: 1,
        origin: window.location.origin,
      },
    },
  };

  const reactPlayerPreview: ReactPlayerProps = {
    url: mediaPopperVideo ? url : '',
    width: '100%',
    height: '100%',
    config,
    controls: false,
    playing: mediaPopperVideo && !!url ? true : false,
    ref: playerRef,
    muted: true,
  };

  return (
    <>
      <Popper
        sx={psylarisDetailPopper}
        open={isModalVisible}
        anchorEl={modalAnchorEl?.current}
        transition
        disablePortal
        placement="right-start"
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} style={{ transformOrigin: 'right-end' }}>
            <Paper className="detail-card">
              <Box className="detail-image-container">
                {!mediaPopperVideo ? (
                  <img className={'detail-image'} src={thumbnail} />
                ) : isLoading ? (
                  <p>loading</p>
                ) : (
                  <DialogMediaPlayer
                    key={url}
                    ReactPlayerProps={reactPlayerPreview}
                    ReactPlayerTriggeredBy={PLayerTriggeredBy.Practitioner}
                  />
                )}
              </Box>
              <Box className="detail-title-container">
                <Typography variant="h4" className="detail-title">
                  {title}
                </Typography>
              </Box>
              <Box className="detail-content-container">
                <Typography variant="body1" className="detail-content">
                  {content}
                </Typography>
              </Box>
            </Paper>
          </Fade>
        )}
      </Popper>
    </>
  );
};

export default PsylarisPannelDetailPopper;
